import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { t } from '../../translations/getTranslation';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import { Paragraph } from '../../components/Styled/typography';
import CardInfo from '../../components/cards/CardInfo';
import { ReplacementCardOnlineChatButton } from '../../components/Button';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
const CantProcess = () => {
    const { isSuccess, isSemu } = useAccountSummary();
    useAnalytics(isSuccess, { isSemu });
    return (_jsxs(_Fragment, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ withImage: true }, { children: [_jsx(LayoutHeading, { title: t('cantProcess.cantProcessOnline'), modalImageProps: { imageName: 'WARNING' } }), _jsxs(Paragraph, { children: [t('cantProcess.pleaseReachOut'), _jsx(ReplacementCardOnlineChatButton, {}), t('cantProcess.forAssistance')] })] }))] }));
};
export default CantProcess;
//# sourceMappingURL=index.js.map